import { defineComponent as i, ref as l, computed as c, resolveComponent as p, openBlock as d, createElementBlock as u, mergeProps as m, toHandlers as f, createVNode as b, normalizeProps as y, guardReactiveProps as k } from "vue";
import { i as h } from "./constants-ByXK9fg4.mjs";
import { O as g } from "./OrIcon-k8cyvh-D.mjs";
import { _ as O } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var s = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Danger = "danger", e))(s || {});
const F = [
  // Layout
  "layout-inline-row justify-center",
  // Box
  "w-[56px]",
  "h-[56px]",
  // Shape
  "rounded-full",
  // Elevation
  "enabled:shadow-button",
  "dark:enabled:shadow-button-dark"
], B = {
  primary: [
    // Theme
    "theme-preset-1-primary",
    "dark:theme-preset-1-primary-dark"
  ],
  danger: [
    // Theme
    "theme-preset-1-error",
    "dark:theme-preset-1-error-dark"
  ]
}, P = i({
  name: "OrFab",
  components: {
    OrIcon: g
  },
  props: {
    icon: {
      type: [String, Object],
      required: !0
    },
    color: {
      type: String,
      default: () => s.Primary
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "click",
    "focus",
    "blur"
  ],
  expose: [
    "root"
  ],
  setup(e, { emit: o }) {
    const n = l(), t = c(() => [
      "or-fab-v3",
      ...F,
      ...B[e.color]
    ]);
    return {
      root: n,
      rootStyles: t,
      isVue3: h,
      onClick: (r) => o("click", r),
      onFocus: (r) => o("focus", r),
      onBlur: (r) => o("blur", r)
    };
  }
}), $ = ["disabled"];
function v(e, o, n, t, r, w) {
  const a = p("OrIcon");
  return d(), u("button", m({
    ref: "root",
    class: e.rootStyles,
    type: "button",
    disabled: e.disabled
  }, f({
    ...e.isVue3 ? {} : e.$listeners,
    click: e.onClick,
    focus: e.onFocus,
    blur: e.onBlur
  }, !0)), [
    b(a, y(k(typeof e.icon == "string" ? { icon: e.icon, size: "l" } : { size: "l", ...e.icon })), null, 16)
  ], 16, $);
}
const V = /* @__PURE__ */ O(P, [["render", v]]);
export {
  s as F,
  V as O
};
//# sourceMappingURL=OrFab-Cbg9unNc.mjs.map
